import { StateContext } from "@ngxs/store";
import { catchError, combineLatest, map, Observable, of, tap } from "rxjs";

import * as API from '@hiptraveler/data-access/api';
import { ItineraryStateModel } from "../itinerary.model";

interface Params {
  ctx: StateContext<ItineraryStateModel>;
  data: API.RequestByIdDto;
  value: API.HotelResultData;
  bookApi: API.BookApiService;
}

export function loadHotelInformation({ ctx, data, value, bookApi }: Params): Observable<unknown> {

  const hotelInformation$ = bookApi.getHotelInformation(data).pipe(
    tap(API.validateResponse),
    map(response => response.data || null),
    catchError(() => of(value))
  );

  const tripAdvisor$ = bookApi.getTripAdvisorData(data, 'hotel').pipe(
    tap(API.validateResponse),
    map(response => response.data || null),
    catchError(() => of(value))
  );

  const hotelContent$ = combineLatest([ hotelInformation$, tripAdvisor$ ]).pipe(
    tap(([ hotelInformation, tripAdvisor ]) => {
      
      if (hotelInformation && !hotelInformation?.taDataMap) {
        hotelInformation['taDataMap'] = tripAdvisor;
      }

      ctx.patchState({ hotelInformation });
    })
  );

  return hotelContent$;
}
